import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBarcode,
  faCopy,
  faMapMarked,
  faFileInvoiceDollar,
} from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";

import api from "../../services/api";
import { moeda } from "../../services/utils";
import "./styles.css";

// Boleto registrado via API do Banco do Brasil (substitui o form mpag quando a
// flag cfgboletoapiativo está ligada). Chama POST /pagamentos/enviaboleto, que é
// idempotente (devolve o boleto já salvo na 2ª via), e exibe a linha digitável.
function BoletoApi({ parcid, via, showRevEndereco, faltando }) {
  const history = useHistory();
  const [carregando, setCarregando] = useState(false);
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState(null);

  const gerar = async () => {
    setCarregando(true);
    setErro(null);
    try {
      const resp = await api.post("pagamentos/enviaboleto", { idParc: parcid });
      if (resp.data && resp.data.boleto) {
        setDados(resp.data.boleto);
      } else {
        setErro("Não foi possível gerar o boleto.");
      }
    } catch (e) {
      // 409 = regra de negócio (parcela vencida fora da janela, cadastro
      // incompleto): o backend manda o texto pronto para o formando. Só o resto
      // é falha técnica e vira "tente novamente".
      const resp = e && e.response;
      if (resp && resp.status === 409 && resp.data && resp.data.msg) {
        setErro(resp.data.msg);
      } else {
        setErro("Não foi possível gerar o boleto. Tente novamente.");
      }
    } finally {
      setCarregando(false);
    }
  };

  const copiar = (texto) => {
    if (texto && navigator.clipboard) navigator.clipboard.writeText(texto);
  };

  // endereço incompleto: encaminha para o perfil (regra herdada do form antigo).
  // O banco recusa registrar boleto sem endereço do pagador, então o botão não
  // tenta e falhar: manda completar, dizendo o que falta.
  if (showRevEndereco) {
    const lista = (faltando || []).join(", ");
    return (
      <button
        type="button"
        className="icone"
        title={
          lista
            ? `Complete seu endereço para gerar o boleto. Faltam: ${lista}.`
            : "Complete seu endereço para gerar o boleto."
        }
        onClick={() => history.push("/perfil")}
      >
        <FontAwesomeIcon icon={faMapMarked} className="icon-partial pending" />
      </button>
    );
  }

  if (!dados) {
    return (
      <div className="boleto-api">
        <button
          type="button"
          className={via === 2 ? "icone" : "icone-e-texto"}
          onClick={gerar}
          disabled={carregando}
          title={via === 2 ? "Ver este boleto" : "Gerar e exibir o boleto"}
        >
          <FontAwesomeIcon icon={faBarcode} />
          {via !== 2 && (
            <span> {carregando ? "GERANDO..." : "EXIBIR BOLETO"}</span>
          )}
        </button>
        {erro && <p className="boleto-erro">{erro}</p>}
      </div>
    );
  }

  return (
    <div className="boleto-api">
      <p className="boleto-info">
        <FontAwesomeIcon icon={faFileInvoiceDollar} /> Boleto gerado —{" "}
        {moeda(dados.valor)}, vencimento {dados.vencimento}.
      </p>
      <p className="boleto-linha">
        <span className="rotulo">Linha digitável</span>
        <span className="codigo">{dados.linhaDigitavel}</span>
        <button
          type="button"
          className="copiar"
          title="Copiar linha digitável"
          onClick={() => copiar(dados.linhaDigitavel)}
        >
          <FontAwesomeIcon icon={faCopy} /> copiar
        </button>
      </p>
      {dados.urlBoleto && (
        <a
          className="icone-e-texto"
          href={dados.urlBoleto}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faBarcode} /> Abrir boleto (2ª via)
        </a>
      )}
    </div>
  );
}

export default BoletoApi;
